module.exports = __webpack_public_path__ + "679a5b1d9cf0c5b6864fb461fd59c593.jpg";